import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/system';
import { useRecordContext } from 'react-admin';

const Label = styled('label')({
  color: 'grey',
  fontSize: 12,
  fontFamily: ['"Roboto"', '"Helvetica"', '"Arial"', 'sans-serif'],
  lineHeight: 1,
  textTransform: 'capitalize',
});

const Link = styled('a')({
  color: '#3f51b5',
  fontSize: 14,
  fontFamily: ['"Roboto"', '"Helvetica"', '"Arial"', 'sans-serif'],
  textDecoration: 'none',
  lineHeight: 1,
});

const MarginNormal = styled('div')({
  marginTop: 12,
  marginBottom: 4,
});

const ModuleVersionLinkField = ({ source, id }) => {
  const record = useRecordContext();
  return (
    <MarginNormal>
      <Label>
        <span>{source} &nbsp;</span>
      </Label>
      <Link href={`#/ModuleVersion/${record.id}/show`}>
        {record[source]}
      </Link>
    </MarginNormal>
  );
};

ModuleVersionLinkField.propTypes = {
  source: PropTypes.string.isRequired,
};

export default ModuleVersionLinkField;
